<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="value-chart-breakdown-modal">
        <div class="modal-dialog" role="document" style="width: 1200px">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            &times;
                        </span>
                    </button>

                    <h4 class="modal-title">
                        Breakdown
                    </h4>
                </div>

                <loading-spinner v-if="loading"/>

                <div v-else class="modal-body">
                    <table class="table table-striped table-condensed">
                        <thead>
                        <tr>
                            <th class="col-xs-5">
                                Description
                            </th>

                            <th class="col-xs-4">
                                Customer
                            </th>

                            <th class="col-xs-4">
                                Portal
                            </th>

                            <th class="col-xs-4">
                                Category
                            </th>

                            <th class="col-xs-2">
                                Price
                            </th>

                            <th class="col-xs-2"></th>

                            <th class="col-xs-3 text-right">
                                Value
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="row in data">
                            <td class="table__ellipsis">
                                {{ row.commission_description }}
                            </td>

                            <td class="table__ellipsis">
                                <router-link :to="'/' + row.commission_customer_type + '/' + row.commission_customer_id" data-dismiss="modal">
                                    {{ row.commission_customer_name }}
                                </router-link>
                            </td>

                            <td>
                                <router-link :to="'/portals/' + row.portal_id" data-dismiss="modal">
                                    {{ row.portal_name }}
                                </router-link>
                            </td>

                            <td>
                                <span v-if="row.commissionable_type === 'publication-based-ads'" class="label" style="background-color: #16a34a">
                                    Ads
                                </span>

                                <span v-if="row.commissionable_type === 'time-based-ads'" class="label" style="background-color: #16a34a">
                                    Ads
                                </span>

                                <span v-if="row.commissionable_type === 'subscription-periods'" class="label" style="background-color: #20aaea">
                                    Subscriptions
                                </span>

                                <span v-if="row.commissionable_type === 'commission-items'" class="label" style="background-color: #e8384f">
                                    Adjustment
                                </span>
                            </td>

                            <td>
                                {{ row.commission_price | price }}
                            </td>

                            <td>
                                <i v-if="row.commission_agency_commission" class="fa fa-building" v-tooltip="getAgencyCommission(row)"></i>

                                <i v-else class="fa fa-building tw-text-gray-300"></i>

                                <i v-if="row.commission_third_party_costs" class="fa fa-users" v-tooltip="getThirdPartyCosts(row)"></i>

                                <i v-else class="fa fa-users tw-text-gray-300"></i>
                            </td>

                            <td class="text-right">
                                <span class="tw-text-gray-300">{{ row.commission_percentage | number }} %</span> {{ row.commission_value | price }}
                            </td>
                        </tr>
                        </tbody>

                        <tfoot>
                        <tr>
                            <td colspan="7" class="text-right">
                                <b>
                                    Total: {{ total | price }}
                                </b>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    props: {
        user: {
            required: true
        },

        month: {
            required: true
        }
    },

    data() {
        return {
            data: null,

            loading: true
        }
    },

    mounted() {
        this.listenForClose()
    },

    watch: {
        month() {
            this.load()
        }
    },

    computed: {
        total() {
            return this.data.reduce((sum, row) => sum + row.commission_value, 0)
        }
    },

    methods: {
        load() {
            this.loading = true

            http.post('/api/v1/reports/new-analytics', {
                metrics: [
                    {name: 'commission_price'},
                    {name: 'commission_agency_commission'},
                    {name: 'commission_third_party_costs'},
                    {name: 'commission_value'},
                ],
                dimensions: [
                    {name: 'commissionable_type'},
                    {name: 'commission_customer_name'},
                    {name: 'commission_customer_type'},
                    {name: 'commission_customer_id'},
                    {name: 'commission_description'},
                    {name: 'commission_percentage'},
                    {name: 'portal_id'},
                    {name: 'portal_name'},
                ],
                filters: [
                    {dimension: 'sold_month', operator: '=', value: this.month},
                    {dimension: 'user_id', operator: '=', value: this.user.id}
                ]
            }).then(response => {
                this.data = response.data.data

                this.loading = false
            })
        },

        getAgencyCommission(row) {
            return 'Agency Commission: ' + this.$options.filters.price(row.commission_agency_commission)
        },

        getThirdPartyCosts(row) {
            return 'Third Party Costs: ' + this.$options.filters.price(row.commission_third_party_costs)
        },

        hide() {
            $(this.$el).modal('hide')
        },

        listenForClose() {
            $(this.$el).on('hidden.bs.modal', this.reset)
        }
    }
}
</script>
